<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="m-flex red-top-nav">
				<div class="back_left" @click="$router.back()"></div>
				<div class="big_tit">{{ $t('rgxq') }}</div>
			</div>

			<div class="money_box">
				<div class="item">
					<!-- <p class="money_num" v-html="'<span>' + $t('utils.moneyMark') + '</span>' + data.on_money"></p> -->
					<p class="money_num" v-html="'<span>USD</span>' + data.usd_on_money"></p>
					<p class="info">{{ $t('user.uncollectedPrincipal') }}</p>
				</div>
				<div class="item">
					<!-- <p class="money_num" v-html="'<span>' + $t('utils.moneyMark') + '</span>' + data.on_apr_money"></p> -->
					<p class="money_num" v-html="'<span>USD</span>' + data.usd_on_apr_money"></p>
					<p class="info">{{ $t('user.uncollectedInterest') }}</p>
				</div>
				<div class="item">
					<!-- <p class="money_num" v-html="'<span>' + $t('utils.moneyMark') + '</span>' + data.ok_apr_money"></p> -->
					<p class="money_num" v-html="'<span>USD</span>' + data.usd_ok_apr_money"></p>
					<p class="info">{{ $t('user.cumulativeIncome') }}</p>
				</div>
			</div>
		</div>
		<h3 class="notes_tit">{{ $t('rgjl') }}</h3>
		<div style="height: 200px;" v-if="Object.keys(data).length > 0 && data.list.length == 0"></div>
		<van-empty :description="$t('orders.noOrders')" v-if="Object.keys(data).length > 0 && data.list.length == 0 && emptys" />
		<div class="scrollBox" v-if="Object.keys(data).length > 0">
			<div class="notes_box" v-if="!emptys" v-for="i in data.list">
				<p class="timer m-flex m-f-between">
					{{ i.time }}
					<!-- <van-count-down v-if="i.status==0" :time="Countdown(i,current_time)*1000" /> -->
					<span class="ing" v-if="i.status == 0">{{ $t('orders.unfinish') }}</span>
					<span class="finish" v-if="i.status == 1">{{ $t('orders.finish') }}</span>
					<span class="fq" v-if="i.status == 2">{{ $t('utils.fqStatus') }}</span>
				</p>
				<div class="item_div1 m-flex">
					<p class="m-f1">
						{{ i[lang] }}
					</p>
					<!-- <div style="margin:0 1em;">{{{0:$t('xi_b'),1:$t('ben_x')}[i.mode] }}</div> -->
					<div style="margin:0 1em;">{{ i.day_text }}</div>
					<!-- <div class="order-btn text-center" v-if="i.project_type == 1 && i.status != 2" @click="fqFun(i)">{{ $t('utils.fq') }}</div> -->
					<!-- <div class="order-btn text-center" @click="$router.push({path:'/contract',query:{time:Math.floor(new Date(i.time).getTime())}})">{{ $t('hetong') }}</div> -->
				</div>
				<div class="item_div2">
					<div class="item_min">
						<p>{{ i.project_type == 1?'$':$t('utils.moneyMark') }}{{ i.money }}</p>
						<p>{{ $t('rgje') }}</p>
					</div>
					<div class="item_rate">
						<p>{{ i.project_type == 1?'$':$t('utils.moneyMark') }}{{ (i.money * i.rate / 100) }}</p>
						<p>{{ $t('shouyi_yj') }}</p>
					</div>
					<div class="item_day">
						<p>{{ $t(i.day) }}</p>
						<p>{{ $t('utils.cycle') }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import {
	Empty,
	Toast,
	Dialog,
	CountDown
} from "vant";

import Fetch from "../../utils/fetch";
Vue.use(Empty);
Vue.use(CountDown);

export default {
	name: "order",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: {},
			emptys: false,
			current_time:''
		};
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.start();
		this.currentTime()
	},
	computed:{
		Countdown:()=>{
			return (item,current_time)=>{
				let time=Math.floor(new Date(item.time).getTime()/1000+86400*item.day),
				num= Math.floor(time-current_time)
				if(num>0){
					return num
				}else{
					return 0
				}
			}
		}
	},
	methods: {
		fqFun(item){
			console.log(item,'item')
			Dialog.confirm({
                    message:this.$t('utils.fqToast'),
                    confirmButtonText:this.$t('utils.confirm'),
                    cancelButtonText:this.$t('utils.cancel')
                })
                .then(() => {
					Fetch("/user/waiverOrder",{id:item.id}).then((r) => {
						if(r.code == 1){
							Toast(r.info)
							start()
						}
					});
                })
                .catch(() => {
                    // on cancel
                });
		},
		currentTime(){
			this.current_time=Math.floor(Date.now()/ 1000)
		},
		start() {
			Fetch("/user/order").then((r) => {
				this.data = r.data;
				r.data.list.length == 0 ?
					(this.emptys = true) :
					(this.emptys = false);
			});
		},
		wan(str) {
			var num = parseFloat(str);
			if (num > 99999) {
				return `${(num / 10000).toFixed(2)}万`;
			} else {
				return str || 0;
			}
		},
		lookHT(id) {
			this.$router.push("/contract/" + id);
		},
	},
};
</script>

<style lang="less" scoped>
.order-btn{
	padding: .5em;
	background-color: #000;
	color: #fff;
	border-radius: .5em;
	width: 8em !important;
}
.red_top_bg {
	height: 136px;
	background: #000;
	background-size: 100% 100%;
	position: fixed;
	z-index: 15;

	.red-top-nav {
		background-color: #fff;
		height: 44px;
	}
}

.money_box {
	margin-top: 15px;
	display: flex;
	padding: 0 6px;
	justify-content: space-around;
	color: #ffffff;

	.item {
		width: 33.33%;
		text-align: center;
		font-weight: bold;
		padding: 0 1px;

		.money_num {
			width: 100%;
			font-size: 16px;
			line-height: 20px;
			white-space: normal;
			word-break: normal;
			text-align: center;
			display: flex;
			justify-content: center;
			padding: 0 2px;
			/deep/ span {
				font-size: 14px;
				width: 35px;
			}
		}

		.info {
			font-size: 14px;
			line-height: 20px;
			margin-top: 2px;
		}
	}
}

.notes_tit {
	width: 100%;
	max-width: 750px;
	line-height: 44px;
	height: 44px;
	font-size: 14px;
	color: #000000;
	padding: 0 14px;
	position: fixed;
	top: 156px;
	left: 50%;
	transform: translateX(-50%);
	background: #FAFAFA;
	z-index: 2;
}

.notes_box {
	width: 100%;
	padding-bottom: 2px;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
	border-radius: 6px;
	margin-bottom: 10px;

	.count-down{
		color: #000 !important;
		margin-right: .5em;
	}
	.timer {
		padding: 12px 14px;
		font-size: 12px;
		color: rgba(0, 0, 0, .6);
		border-bottom: 1px solid #ececec;
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			font-style: normal;
			padding: 5px;
			border-radius: 5px;
			color: #FFFFFF;
		}

		.ing {
			background: #000000;
		}

		.finish {
			font-style: normal;
			background: #07c160;
		}
		.fq {
			font-style: normal;
			background: #f0150a;
		}
	}

	.item_div1 {
		display: flex;
		justify-content: space-between;
		padding: 15px 10px;

		p:nth-child(1) {
			width: 100%;
			font-weight: bold;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;

		}
	}

	.item_div2 {
		display: flex;
		justify-content: space-between;
		text-align: center;
		margin-bottom: 10px;

		div {
			width: 33.33%;

			p {
				padding: 5px 0;
			}
		}

		.item_rate {
			p:nth-child(1) {
				font-weight: bold;
				font-size: 14px;
				color: #000;

			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_day {
			p:nth-child(1) {
				font-weight: bold;
				font-size: 14px;

			}

			p:nth-child(2) {
				color: #999;
			}
		}

		.item_min {
			p:nth-child(1) {
				font-weight: bold;
				font-size: 14px;

			}

			p:nth-child(2) {
				color: #999;
			}
		}
	}
}

.scrollBox {
	margin-top: 200px;
	width: 96%;
	margin-left: 2%;
}
.back_left {
	margin-top: 0px;
}
</style>
